module.exports = __webpack_public_path__ + "static/media/iPhone14_5.d464f110.png";